module.exports = '<svg width="19" height="32" viewBox="0 0 19 32"><path d="M17.6 0h-3.2a1.6 1.6 0 0 0-1.6 1.6v28.8a1.6 1.6 0 0 0 1.6 1.6h3.2a1.6 1.6 0 0 0 1.6-1.6V1.6A1.6 1.6 0 0 0 17.6 0zM4.8 0H1.6A1.6 1.6 0 0 0 0 1.6v28.8A1.6 1.6 0 0 0 1.6 32h3.2a1.6 1.6 0 0 0 1.6-1.6V1.6A1.6 1.6 0 0 0 4.8 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pause-2.js
// module id = 1336
// module chunks = 14